import * as React from 'react'
import {useEffect, useRef} from 'react'
import ScrollBar from 'react-perfect-scrollbar'
import {Lang} from 'yougile-lang'
import {Time, Util} from 'yougile-util'
import {DeadlineStickerEntry, isSetSticker} from 'yougile-model'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {UserAvatar} from '../../../../components/user-avatar'

export const DeadlineBeforeEdit = (props: {
  edit(): void
  history: DeadlineStickerEntry[]
  value: string
  startValue: string
  canEdit?: boolean
}) => {
  const scrollContainer = useRef<ScrollBar>(null)
  const {edit, history, value, startValue, canEdit} = props
  const hstRow = (dl: DeadlineStickerEntry, ix: number) => {
    const txt =
      (isSetSticker(dl.startDate)
        ? Time.formatDate(dl.startDate) + ' – '
        : '') +
      (dl.withTime
        ? Time.formatDateTime(dl.deadline, false, false, true)
        : Time.formatDate(dl.deadline))
    return (
      <div key={ix} className="sticker-deadline-edit-hist-item">
        <div className="sticker-deadline-edit-hist-n">{ix + 1}.</div>
        <div className="sticker-deadline-edit-hist-val">{txt}</div>
        <UserAvatar userId={dl.by} />
      </div>
    )
  }
  useEffect(() => {
    if (scrollContainer.current) {
      scrollContainer.current.updateScroll()
    }
  }, [history?.length])

  const bem = Util.bemFrom('sticker-menu-deadline')
  return (
    <>
      <div className="sticker-deadline-edit-head">
        <div>
          {canEdit && (
            <div className="sticker-deadline-edit-icon" onClick={edit} />
          )}
          {value ? (
            <span className={bem('edit-val')}>
              {startValue ? startValue + ' –' : ''} {value}
            </span>
          ) : (
            <span className={bem('edit-val', {empty: true})}>
              {Lang.msg.dateNotSet}
            </span>
          )}
        </div>

        {canEdit && (
          <div className="sticker-deadline-edit-mark _link" onClick={edit}>
            {Lang.msg.change}
          </div>
        )}
      </div>

      <div className="sticker-deadline-edit-hist">
        <div className="sticker-deadline-edit-hist-head pl-[7px]">
          {Lang.msg.historyChanges}
        </div>
        <WithPerfectScrollbar
          ref={scrollContainer}
          className="max-h-[120px] px-[7px]"
        >
          {history.filter(Boolean).map(hstRow)}
        </WithPerfectScrollbar>
      </div>
    </>
  )
}
